import React, {
  forwardRef,
  useEffect,
  useRef,
  useState,
  useImperativeHandle,
} from "react";
import Select from "react-select";
import { format } from "date-fns";
import { calender } from "../../Helpers/Images";
import ModalPopup from "../../../common/components/ModalPopup/ModalPopup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const QuestionaryPopup = forwardRef(
  (
    {
      actvities,
      popup,
      selectedActivity,
      selectedTtdIndex,
      onClose,
      ttdDate,
      isMobile,
      activityDetails,
    },
    ref
  ) => {
    const [questions, setQuestions] = useState(popup || false);
    const [activityId, setActivityId] = useState(selectedActivity || []);
    const [ttdIndex, setTtdIndex] = useState(selectedTtdIndex || {});
    const [answers, setAnswers] = useState([]);
    const [activities, setActivities] = useState(actvities || []);
    const [questionaryCalender, setQuestionaryCalender] = useState(false);
    const [error, setError] = useState({});
    const [date, setDate] = useState("");
    const [selectedDobDate, setSelectedDobDate] = useState(null);
    const [activeDateQuestion, setActiveDateQuestion] = useState(null);
    const initialAnswersRef = useRef("[]");

    useEffect(() => {
      if (!ttdIndex || !activities?.length) return;

      const currentSlot =
        activities[ttdIndex.dayIndex]?.activities?.[
          ttdIndex.activitySlotIndex
        ] || [];

      const prefilledAnswers = [];

      currentSlot.forEach((slot) => {
        if (slot.ttdQuestion?.length > 0) {
          slot.ttdQuestion.forEach((q) => {
            const existing = prefilledAnswers.find(
              (a) => a.id === q.id && a.packageid === q.packageid
            );
            if (!existing) {
              prefilledAnswers.push({ ...q });
            }
          });
        }
      });

      setAnswers(prefilledAnswers);
      initialAnswersRef.current = JSON.stringify(prefilledAnswers);
    }, [ttdIndex, activities]);

    useEffect(() => {
      const date = new Date(ttdDate);
      const formattedDate = format(date, "dd MMM, yyyy");
      setDate(formattedDate);
    }, [ttdDate]);

    const handleQuestion = (
      questionObj,
      questionIndex,
      eventOrValue,
      optional,
      type,
      packageid,
      isMulti = false
    ) => {
      let value;
      if (typeof eventOrValue === "string") {
        value = eventOrValue;
      } else if (Array.isArray(eventOrValue)) {
        value = eventOrValue[0] || "";
      } else {
        value = eventOrValue?.target?.value;
      }

      const existingIndex = answers.findIndex(
        (item) => item.id === questionIndex && item.packageid === packageid
      );

      const updatedAnswers = [...answers];

      if (existingIndex !== -1) {
        updatedAnswers[existingIndex] = {
          ...updatedAnswers[existingIndex],
          options: value,
        };
      } else {
        updatedAnswers.push({
          id: questionIndex,
          options: value,
          optional,
          question: questionObj.question,
          type,
          packageid,
        });
      }

      setAnswers(updatedAnswers);
      setError((prev) => {
        const newErr = { ...prev };
        delete newErr[`${questionIndex}_${packageid}`];
        return newErr;
      });
    };

    useEffect(() => {
      const dobQuestion = activityId[0]?.package_questions?.find(
        (q) => q.question === "DATE"
      );

      if (dobQuestion) {
        const dobAnswer = answers.find(
          (a) =>
            a.id === dobQuestion.id && a.packageid === activityId[0].package_id
        );
        if (dobAnswer?.options?.[0]) {
          const savedDate = new Date(dobAnswer.options[0]);
          if (!isNaN(savedDate)) setSelectedDobDate(savedDate);
        }
      }
    }, [answers]);

    const handleSubmit = () => {
      const newErrors = {};
      let isValid = true;

      activityId.forEach((activity) => {
        activity.package_questions.forEach((q) => {
          const key = `${q.id}_${activity.package_id}`;
          const answer = answers.find(
            (a) => a.id === q.id && a.packageid === activity.package_id
          );
          const hasValue = answer?.options?.length;

          if (!q.optional && !hasValue) {
            newErrors[key] = `${q.question} is required`;
            isValid = false;
          }
        });
      });

      setError(newErrors);

      if (!isValid) return;

      const updatedActivities = [...activities];
      const dayActivities = [
        ...updatedActivities[ttdIndex.dayIndex].activities,
      ];

      const updatedSlots = dayActivities[ttdIndex.activitySlotIndex].map(
        (slot) => {
          const prevTtdQuestion = slot.ttdQuestion || [];
          const relatedAnswers = answers.filter(
            (answer) => answer.packageid === slot.activity_activity_package_id
          );

          const mergedAnswers = [...prevTtdQuestion];

          relatedAnswers.forEach((newAnswer) => {
            const existingIndex = mergedAnswers.findIndex(
              (a) =>
                a.id === newAnswer.id && a.packageid === newAnswer.packageid
            );

            if (existingIndex !== -1) {
              mergedAnswers[existingIndex] = newAnswer;
            } else {
              mergedAnswers.push(newAnswer);
            }
          });

          return {
            ...slot,
            ttdQuestion: mergedAnswers,
          };
        }
      );

      dayActivities[ttdIndex.activitySlotIndex] = updatedSlots;
      updatedActivities[ttdIndex.dayIndex].activities = dayActivities;

      setActivities(updatedActivities);
      onClose(false);
    };
    const handleClose = () => {
      const normalizeAnswers = (ans) =>
        ans.map((a) => ({
          ...a,
          options: Array.isArray(a.options) ? a.options : [a.options],
        }));
      const hasUnsavedChanges =
        JSON.stringify(normalizeAnswers(answers)) !==
        JSON.stringify(normalizeAnswers(JSON.parse(initialAnswersRef.current)));
      if (hasUnsavedChanges) {
        const confirmSave = window.confirm(
          "You have unsaved changes. Do you want to save them?"
        );

        if (confirmSave) {
          handleSubmit();
        } else {
          const confirmDiscard = window.confirm(
            "Are you sure you want to discard your changes?"
          );

          if (confirmDiscard) {
            onClose(false);
          }
        }
      } else {
        onClose(false);
      }
    };
    useImperativeHandle(ref, () => ({
      handleClose,
    }));
    return (
      <>
        {questions &&
          activityId?.map((item, index) => (
            <div
              className="activites-questionary"
              key={index}
              onClick={() =>
                !isMobile
                  ? questionaryCalender && setQuestionaryCalender(false)
                  : null
              }
            >
              <div className="activites-questionary__header">
                <div className="activites-questionary__header__fill-the-details">
                  <h4>Fill the details</h4>
                </div>
              </div>
              <div className="activites-questionary__product">
                <div className="activites-questionary__product__ticket">
                  <div className="activites-questionary__product__ticket__name">
                    {activityDetails.products_name}
                  </div>
                  <div className="activites-questionary__product__ticket__productname">
                    {activityDetails.package_name}
                  </div>
                </div>
                <div className="activites-questionary__product__date">
                  <img src={calender} alt="calender" />{" "}
                  <div className="activites-questionary__product__date__rhs">
                    {date}
                  </div>
                </div>
              </div>

              <div className="activites-questionary__questions">
                {item.package_questions?.map((q, qIndex) => {
                  if (q.type === "FREETEXT") {
                    return (
                      <div
                        className="activites-questionary__questions__data"
                        key={qIndex}
                      >
                        <h4>{q.question}</h4>
                        <div className="activites-questionary__questions__items__plain-text">
                          <input
                            placeholder="enter your details"
                            value={
                              answers.find(
                                (a) =>
                                  a.id === q.id &&
                                  a.packageid === item.package_id
                              )?.options || ""
                            }
                            onChange={(e) =>
                              handleQuestion(
                                q,
                                q.id,
                                e,
                                q.optional,
                                q.type,
                                item.package_id
                              )
                            }
                          />
                        </div>
                        {error[`${q.id}_${item.package_id}`] && (
                          <div className="error-text">
                            {error[`${q.id}_${item.package_id}`]}
                          </div>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}

                {item.package_questions?.map((q, qIndex) => {
                  if (q.type === "OPTION") {
                    const selectedValue =
                      answers.find(
                        (a) => a.id === q.id && a.packageid === item.package_id
                      )?.options || "";

                    const dropdownOptions = q.options.map((opt) => ({
                      label: opt,
                      value: opt,
                    }));

                    const selectedOption =
                      dropdownOptions.find(
                        (opt) => opt.value === selectedValue
                      ) || null;

                    return (
                      <div
                        className="activites-questionary__questions__dropdown"
                        key={qIndex}
                      >
                        <h4>{q.question}</h4>
                        <div className="activites-questionary__questions__dropdown__select">
                          <Select
                            placeholder="select your options"
                            options={dropdownOptions}
                            isMulti={false}
                            value={selectedOption}
                            onChange={(selectedOption) => {
                              handleQuestion(
                                q,
                                q.id,
                                selectedOption?.value || "",
                                q.optional,
                                q.type,
                                item.package_id,
                                false
                              );
                            }}
                            className="custom-select"
                            classNamePrefix="custom"
                          />
                        </div>
                        {error[`${q.id}_${item.package_id}`] && (
                          <div className="error-text">
                            {error[`${q.id}_${item.package_id}`]}
                          </div>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}

                {item.package_questions?.map((q, qIndex) => {
                  if (q.type === "DATE") {
                    const dobValue =
                      answers.find(
                        (a) => a.id === q.id && a.packageid === item.package_id
                      )?.options || "";

                    return (
                      <div
                        className="activites-questionary__questions__data"
                        key={qIndex}
                      >
                        <h4>{q.question}</h4>
                        <div className="activites-questionary__questions__items__plain-text">
                          <input
                            placeholder="Select Date"
                            value={dobValue}
                            readOnly
                            onClick={() => {
                              setQuestionaryCalender((prev) => !prev);
                              setActiveDateQuestion(q);
                            }}
                          />
                        </div>
                        {error[`${q.id}_${item.package_id}`] && (
                          <div className="error-text">
                            {error[`${q.id}_${item.package_id}`]}
                          </div>
                        )}
                      </div>
                    );
                  }
                  return null;
                })}

                {!isMobile && questionaryCalender && (
                  <div
                    className="activites-questionary__questions__calender"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <div className="flight-results dateMain questionary_calender">
                      <DatePicker
                        selected={selectedDobDate}
                        onChange={(date) => {
                          setSelectedDobDate(date);
                          setQuestionaryCalender(false);
                          const formattedDate = `${date.getFullYear()}-${String(
                            date.getMonth() + 1
                          ).padStart(2, "0")}-${String(date.getDate()).padStart(
                            2,
                            "0"
                          )}`;

                          if (activeDateQuestion) {
                            handleQuestion(
                              activeDateQuestion,
                              activeDateQuestion.id,
                              { target: { value: formattedDate } },
                              activeDateQuestion.optional,
                              activeDateQuestion.type,
                              item.package_id
                            );
                          }
                        }}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={
                          activeDateQuestion?.question === "Date of Birth"
                            ? new Date()
                            : new Date(
                                new Date().setFullYear(
                                  new Date().getFullYear() + 25
                                )
                              )
                        }
                        minDate={
                          activeDateQuestion?.question === "Date of Birth"
                            ? new Date(1900, 0, 1)
                            : new Date()
                        }
                        placeholderText="Select Date"
                        inline
                      />
                    </div>
                  </div>
                )}

                <ModalPopup
                  open={isMobile && questionaryCalender}
                  handleClose={() => setQuestionaryCalender(false)}
                  className="bottomSheetMain"
                >
                  <div>
                    <div>
                      <DatePicker
                        selected={selectedDobDate}
                        onChange={(date) => {
                          setSelectedDobDate(date);
                          setQuestionaryCalender(false);
                          const formattedDate = `${date.getFullYear()}-${String(
                            date.getMonth() + 1
                          ).padStart(2, "0")}-${String(date.getDate()).padStart(
                            2,
                            "0"
                          )}`;

                          if (activeDateQuestion) {
                            handleQuestion(
                              activeDateQuestion,
                              activeDateQuestion.id,
                              { target: { value: formattedDate } },
                              activeDateQuestion.optional,
                              activeDateQuestion.type,
                              item.package_id
                            );
                          }
                        }}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        maxDate={
                          activeDateQuestion?.question === "Date of Birth"
                            ? new Date()
                            : new Date(
                                new Date().setFullYear(
                                  new Date().getFullYear() + 25
                                )
                              )
                        }
                        minDate={
                          activeDateQuestion?.question === "Date of Birth"
                            ? new Date(1900, 0, 1)
                            : new Date()
                        }
                        placeholderText="Select Date"
                        inline
                      />
                    </div>
                  </div>
                </ModalPopup>
                <div className="activites-questionary__questions__submit">
                  <button className="submit-button" onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            </div>
          ))}
      </>
    );
  }
);

export default QuestionaryPopup;
